import { AlertCircleIcon } from '@untitledui-icons/react/solid'
import { cn } from '@/lib/utils'
import type { PriorityLevel } from '@/types/conversation'

const filledBars: Record<Exclude<PriorityLevel, 'critical'>, number> = {
  low: 1,
  medium: 2,
  high: 3,
}
const barHeights = ['h-1/3', 'h-2/3', 'h-full']

export function NotePriorityIcon({ priority }: { priority: PriorityLevel }) {
  if (priority === 'critical') {
    return (
      <AlertCircleIcon className="size-3 text-gray-900 dark:text-gray-100" aria-hidden="true" />
    )
  }

  return (
    <span className="inline-flex h-2.5 w-2 items-end gap-px" aria-hidden="true">
      {barHeights.map((height, index) => (
        <i
          key={height}
          className={cn(
            'block w-0.5',
            height,
            index < filledBars[priority]
              ? 'bg-gray-900 dark:bg-gray-100'
              : 'bg-gray-300 dark:bg-gray-600'
          )}
        />
      ))}
    </span>
  )
}
